module.exports = __webpack_public_path__ + "static/media/the-massive-farms-emerging-beneath-our-cities.07c6ab9b.jpg";